import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, shortDescription, imgUrl, link, onClick }) => {
  return (

    <Col size={12} sm={6} md={4}>
      <div
        className="proj-imgbx"
        data={title}
        onClick={onClick ? onClick : () => { if (link) window.open(link, '_blank', 'noopener,noreferrer'); }}
        style={{ cursor: 'pointer' }}
      >
        <div className="proj-img" >
          <img src={imgUrl} />
        </div>
        <div className="proj-txtx">
          <span>{description || shortDescription}</span>
        </div>
      </div>
    </Col>
  )
}
